import React from 'react';
import { Container } from '../components/Container';
import { Section } from '../components/Section';
import { Reveal } from '../components/Reveal';
import { AppImage } from '../components/AppImage';
import { PageIntro } from '../components/PageIntro';
import { ContactForm } from '../components/contact/ContactForm';
import { ContactAside } from '../components/contact/ContactAside';
import { NextSteps } from '../components/contact/NextSteps';
import { ContactFaq } from '../components/contact/ContactFaq';
import { CalEmbedModal } from '../components/contact/CalEmbedModal';
import { ContactBookingProvider } from '../contexts/ContactBookingContext';
import { contactHeroImage } from '../data/contactImages';
export function Contact() {
  return <ContactBookingProvider data-id="element-974" data-mp="12yh87ovoeis1">
      <PageIntro eyebrow="Contact" title="Tell us what you are trying to sell." lede="Eight fields, one business day for a reply. Send a paragraph about the company, the deadline and roughly what you have to spend — that is enough for us to be useful on the first call." data-id="element-975" data-mp="fa7r309eqj78" />

      <Container data-id="element-976" data-mp="19h0ni0tl5lpt">
        <Reveal data-id="element-977" data-mp="19gigqa9arp3n">
          <AppImage src={contactHeroImage.image} alt={contactHeroImage.alt} ratio="21:9" data-id="element-978" data-mp="19fz15074dcss" />
        </Reveal>
      </Container>

      <Section bordered labelledBy="contact-form-title" data-id="element-979" data-mp="1e8ip8r3fnqbu">
        <Container data-id="element-980" data-mp="1j73ejvh5cpli">
          <div className="grid gap-14 lg:grid-cols-12 lg:gap-10" data-id="element-981" data-mp="1j5ike6yqv8o6">
            <div className="lg:col-span-7" data-id="element-982" data-mp="mh2ta6fzkr8y">
              <Reveal data-id="element-983" data-mp="mi5jsd9ecroc">
                <ContactForm data-id="element-984" data-mp="mixfdo2zupem" />
              </Reveal>
            </div>

            <div className="lg:col-span-5" data-id="element-985" data-mp="qiocsan103s4">
              <Reveal delay={0.06} data-id="element-986" data-mp="vh96dr7rvp7l">
                <ContactAside data-id="element-987" data-mp="vg7p3505y6hf" />
              </Reveal>
            </div>
          </div>
        </Container>
      </Section>

      <NextSteps data-id="element-988" data-mp="10hx0wmv7mo6k" />
      <ContactFaq data-id="element-989" data-mp="10e9c210pmpy6" />

      <CalEmbedModal data-id="element-990" data-mp="26woarg2b9jcq" />
    </ContactBookingProvider>;
}